<template>
    <div class="search searchPage" ref="middle_page">
        <div class="primarylists">
            <ul class="container">
                <li>
                    <div class="primarylists list-mobile mg-mb" style="margin-top: 0;">
                        <div class="titles clear">
                            <img src="../../../static/images/icon-st.jpg" alt="" />
                            <div class="title l" style="text-transform: uppercase!important;">{{ $t("new.title5") }}</div>
                        </div>
                    </div>
                    <div class="lessons" style="margin-top: 0;">
                        <ul class="clear">
                            <template v-if="resultFlag">
                                <li v-for="(item, index) in nqtData" :key="index" :id="item.courseId">
                                    <div v-if="!item.isUrl">
                                        <div class="img vaa">
                                            <img :src="item.courseCover" alt="/" @click="goto_Aicourse(item.courseId)" />
                                        </div>
                                        <div class="lessontitle" @click="goto_Aicourse(item.courseId)" style="-webkit-box-orient: vertical;">
                                            {{ item.courseName }}
                                        </div>
                                        <!-- <div class="introduce-new" style="-webkit-box-orient: vertical;" @click="goto_Aicourse(item.courseId)" v-html="item.synopsis"></div> -->
                                    </div>
                                    <div v-else>
                                        <div class="img vaa">
                                            <span v-html="item.courseCover"></span>
                                        </div>
                                        <div class="lessontitle" @click="goto_Aicourse(item.courseId)" style="-webkit-box-orient: vertical;">
                                            {{ item.courseName }}
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div v-if="!resultFlag" class="no-content mg-nocontent">
                        <img src="../../../static/images/noresult.jpg" alt />
                        <p>{{ $t("search.result") }}</p>
                    </div>
                </li>
            </ul>
        </div>
        <button v-if="mobile" class="btn-tast btn-next-1" @click="back()">
            <img src="../../../static/images/icon-back-1.png"/>
            <span class="nqt-text">{{ $t("common.returnButton") }}</span>
        </button>
        <!-- Phân trang -->
        <div style="text-align: center; margin-top: 10px;" v-if="resultFlag">
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="searchResultList.length"></el-pagination>
        </div>
    </div>
</template>
<script>
    //国际化引入
    import Vue from "vue";
    import { mapMutations } from "vuex";
    import { lang } from "../../assets/languages/getLanguageType.js";
    Vue.prototype.$lang = lang;

    export default {
        name: "search",
        data() {
            return {
                keyword: "",
                searchResultList: [],
                resultFlag: true,
                pageNum: 1,
                page: 1,
                pageSize: 5,
            };
        },
        methods: {
            handleCurrentChange(val) {
                this.page = val;
            },
            back() {
                let historySearch = window.sessionStorage.getItem("historySearch");
                this.$router.push({
                    path: historySearch,
                });
            },
            search() {
                this.pageNum = 1;
                this.page = 1;
                this.$api
                    .post("/courseStudy/getCourseByKeywordNew", {
                        keyword: this.keyword,
                        languageType: this.$lang()
                    })
                    .then((response) => {
                        if (response.data.list.length > 0) {
                            this.resultFlag = true;
                            let data = response.data.list;
                            data.forEach((item, i) => {
                                if (item.courseCover == undefined || item.courseCover == null || item.courseCover == "") {
                                    item.courseCover = "../../../static/images/temppic.jpg";
                                }
                            });
                            // this.searchResultList = data;
                            this.checkIsUrl(data);
                        } else {
                            this.searchResultList = [];
                            this.resultFlag = false;
                        }
                        document.getElementById("app").scrollTo(0, 0);
                    });
            },
            checkIsUrl (val) {
                let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);
                val.forEach(el => {
                    if (regex.test(el.synopsis)) {
                        el['isUrl'] = true;
                        let url = el.synopsis.split("\r\n");
                        el.courseCover = "<iframe width='100% !important' height='100% !important' src='" + url[1] + "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
                    } else {
                        el['isUrl'] = false;
                    }
                })
                this.searchResultList = val;
            },
            ...mapMutations("header", ["setHistory"]),
            // Đến trang chi tiết khóa học.
            goto_Aicourse: function (courseId) {
                // let userId = window.sessionStorage.getItem("id");
                // if (userId == "" || userId == null) {
                //     this.$alert(window.vm.$i18n.t("js.PleaseLogin"), "", {
                //         confirmButtonText: window.vm.$i18n.t("js.confirm"),
                //     });
                //     return;
                // } else {
                //     window.sessionStorage.setItem("courseGOBackNum", 4);
                //     window.sessionStorage.setItem("wr_search_keyword", this.keyword),
                //     this.$router.push({
                //         name: "Aicourse",
                //         query: {
                //             buyCourseId: courseId,
                //             buyCollegeId: JSON.stringify(1),
                //         },
                //     });
                // }
                window.sessionStorage.setItem("courseGOBackNum", 4);
                this.setHistory("/home/search");
                window.sessionStorage.setItem("wr_search_keyword", this.keyword),
                // this.$router.push({
                //     name: "Aicourse",
                //     query: {
                //         buyCourseId: courseId,
                //         buyCollegeId: JSON.stringify(1),
                //     },
                // });
                //-----------------■コースセット対応--------------------------------------
                this.$api
                .post("/coursesPurchase/isScheduleCourse", {
                    courseId: courseId
                })
                .then(response => {
                    let isScheduleCourseFlag = response.data;
                    if (isScheduleCourseFlag == 1) {
                        this.$message.warning(window.vm.$i18n.t("new.title192"));
                        return ;
                    }else {
                        // Đi đến chi tiết khóa học
                        this.$router.push({
                            name: "Aicourse",
                            query: {
                                buyCourseId: courseId,
                                buyCollegeId: JSON.stringify(1),
                            },
                        });
                    }
                });
                //-----------------■コースセット対応--------------------------------------
            }
        },
        computed: {
            mobile () {
                return this.$store.getters['header/mobile'];
            },
            nqtData() {
                this.pageSize = this.mobile ? 4 : 15;
                return this.searchResultList.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
            },
        },
        mounted() {
            this.keyword = this.$route.query.keyword;
        },
        watch: {
            $route() {
                this.keyword = this.$route.query.keyword;
            },
            keyword() {
                this.search();
            },
        },
    };
</script>
<style scoped>
    .primarylists .lessons .introduce {
        -webkit-box-orient: vertical !important;
    }
    .vn .primarylists .lessons .introduce {
        -webkit-box-orient: vertical !important;
    }
    .nqt-mobie {
        display: none;
    }
    @media (max-width: 834px) {
        .nqt-mobie {
            display: block !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/search/search.vue